import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Flex } from '@magnetic/flex'
import { Text } from '@magnetic/text'
import { Layout } from '@/components/layout'
import { DashboardPage } from '@/pages/dashboard'
import { IssuesPage } from '@/pages/issues'
import { ProjectsPage } from '@/pages/projects'
import { ProjectDetailPage } from '@/pages/project-detail'
import { ApplicationDetailPage } from '@/pages/application-detail'
import { AdminPage } from '@/pages/admin'
import AdminAllProjects from '@/pages/admin-all-projects'
import { AdminUsersPage } from '@/pages/admin-users'
import { AdminAuditLogsPage } from '@/pages/admin-audit-logs'
import { ECRAdminPage } from '@/pages/ecr-admin'
import { SettingsPage } from '@/pages/settings'
import { useAuth } from '@/lib/use-auth'
import { Spinner } from '@magnetic/spinner'

// Loading screen using Magnetic Spinner
function LoadingScreen() {
  return (
    <Flex align="center" justify="center" style={{ minHeight: '100vh' }}>
      <Flex direction="vertical" align="center" gap={16}>
        <Spinner size="lg" />
        <Text color="light">Loading...</Text>
      </Flex>
    </Flex>
  )
}

function App() {
  const { isAuthenticated, isLoading, login } = useAuth()

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      login() // Redirects to /auth/login (SSO)
    }
  }, [isLoading, isAuthenticated, login])

  // Show loading screen while checking auth or redirecting
  if (isLoading || !isAuthenticated) {
    return <LoadingScreen />
  }

  // Authenticated routes
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/issues" element={<IssuesPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
        <Route path="/projects/:projectId/applications/:appId" element={<ApplicationDetailPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/projects" element={<AdminAllProjects />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/audit-logs" element={<AdminAuditLogsPage />} />
        <Route path="/admin/ecr" element={<ECRAdminPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Routes>
    </Layout>
  )
}

export default App
